import { useQuery } from "@tanstack/react-query"

import { getCartClient } from "@/lib/client/api/cart"

export const useCartDetail = () => {
  return useQuery({
    queryKey: ["cart"],
    queryFn: getCartClient,
    staleTime: 30000, // Consider data fresh for 30 seconds
    refetchOnWindowFocus: true,
  })
}
